import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import MassagePushConfigurationComponent from './component';
import { Checkbox, Input } from 'udesk-ui';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import { language } from 'src/components/common/b-editor';
import AssociateSelect from 'src/components/common/associate-select';
import UserSelect from 'src/components/common/UserSelect';
import RoleSelect from 'src/components/common/RoleSelect';
import TicketConfig from './components/TicketConfig';
import CallingRobotConfig from './components/CallingRobotConfig';
import './style.scss';

const braftEditorStyle = {
    border: '1px solid #d9d9d9',
};

export default class MassagePushConfigurationTemplate extends MassagePushConfigurationComponent {
    render() {
        let { privates, props, actions, locales } = this;

        const { showPresetPushUser = true, showCustomPushEmail = false } = props;

        let { pushConf } = privates;
        const extendControls = (pushConf) => [
            {
                key: 'custom-dropdown',
                type: 'dropdown',
                autoHide: true,
                text: locales.enums.common.operatorTypes.associate,
                component: (
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: 16,
                            overflow: 'auto',
                            height: 300,
                        }}
                    >
                        <AssociateSelect
                            onClick={
                                props.associateDataClickInRich || actions.associateDataClickInRich
                            }
                            pushConfContentChange={actions.pushConfContentChange}
                            pushConf={pushConf}
                            // associateDivRef={privates.associateDivRef}
                            // textAreaRef={privates.textAreaRef}
                            taskType={props.taskType}
                            taskTypeList={props.taskTypeList}
                            taskId={props.taskId}
                        ></AssociateSelect>
                    </div>
                ),
            },
        ];

        return (
            <React.Fragment>
                {/* 系统消息 */}
                <If
                    condition={
                        parseInt(pushConf.actionType, 10) === Udesk.enums.messagePushType.system.id
                    }
                >
                    <div className="massage-push-configuration-row">
                        <div className="massage-push-configuration-row-label">
                            {locales.components.massageConfiguration.pushTarget}
                        </div>
                        <div className="massage-push-configuration-row-content">
                            {showPresetPushUser && (
                                <div>
                                    <Checkbox.Group
                                        options={privates.autoAddPushTargets}
                                        value={pushConf.actionDetails.pushTargetList}
                                        onChange={actions.onTargetsChange.params(
                                            pushConf.actionType
                                        )}
                                    />
                                </div>
                            )}
                            <Checkbox
                                checked={privates.showCustomize}
                                onChange={actions.showCustomize.params(pushConf)}
                            >
                                {/* 自定义推送目标 */}
                                {
                                    UdeskLocales['current'].components.massagePushConfiguration
                                        .otherPush.template.customPushDestination
                                }
                            </Checkbox>
                            <If condition={privates.showCustomize}>
                                <div className="massage-push-configuration-child-row">
                                    <div className="massage-push-configuration-child-row-label">
                                        {locales.components.massageConfiguration.sysUser}
                                    </div>
                                    <div className="massage-push-configuration-child-row-content">
                                        <UserSelect
                                            mode="multiple"
                                            getPopupContainer={(triggerNode) =>
                                                triggerNode.parentElement
                                            }
                                            allowClear
                                            style={{ width: '100%' }}
                                            defaultValue={pushConf.actionDetails.pushUserList}
                                            onChange={actions.onSelectChange.params(
                                                'pushUserList',
                                                pushConf.actionType
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="massage-push-configuration-child-row">
                                    <div className="massage-push-configuration-child-row-label">
                                        {locales.components.massageConfiguration.sysRole}
                                    </div>
                                    <div className="massage-push-configuration-child-row-content">
                                        <RoleSelect
                                            mode="multiple"
                                            getPopupContainer={(triggerNode) =>
                                                triggerNode.parentElement
                                            }
                                            allowClear
                                            style={{ width: '100%' }}
                                            defaultValue={pushConf.actionDetails.pushRoleList}
                                            onChange={actions.onSelectChange.params(
                                                'pushRoleList',
                                                pushConf.actionType
                                            )}
                                        />
                                    </div>
                                </div>
                            </If>
                        </div>
                    </div>
                </If>
                {/* 邮件 */}
                <If
                    condition={[
                        Udesk.enums.messagePushType.email.id,
                        Udesk.enums.messagePushType.udesk.id,
                    ].includes(parseInt(pushConf.actionType, 10))}
                >
                    <div className="massage-push-configuration-row">
                        <div className="massage-push-configuration-row-label">
                            {locales.components.massageConfiguration.emailPushTarget}
                        </div>
                        <div className="massage-push-configuration-row-content">
                            {props.taskType !== Udesk.enums.inspectDataSources.wechatDialogue.id &&
                                !showCustomPushEmail && (
                                    <div>
                                        <Checkbox
                                            onChange={actions.onPushObjectTypeChange.params(
                                                pushConf.actionType
                                            )}
                                            checked={
                                                pushConf.actionDetails.pushTargetType ===
                                                Udesk.enums.pushObjectTypes.staff.id
                                            }
                                        >
                                            {Udesk.enums.pushObjectTypes.staff.name}
                                        </Checkbox>
                                        <Checkbox.Group
                                            options={privates.autoAddPushTargets.slice(0, 5)}
                                            value={pushConf.actionDetails.pushTargetList}
                                            onChange={actions.onTargetsChange.params(
                                                pushConf.actionType
                                            )}
                                        />
                                    </div>
                                )}
                            {showCustomPushEmail ? (
                                <Checkbox checked>
                                    {/* 自定义推送目标 */}
                                    {
                                        UdeskLocales['current'].components.massagePushConfiguration
                                            .otherPush.template.customPushDestination
                                    }
                                </Checkbox>
                            ) : null}
                            <div className="massage-push-configuration-child-row">
                                {props.taskType !==
                                    Udesk.enums.inspectDataSources.wechatDialogue.id && (
                                    <div className="massage-push-configuration-child-row-label">
                                        {[Udesk.enums.messagePushType.udesk.id].includes(
                                            parseInt(pushConf.actionType, 10)
                                        )
                                            ? locales.components.massageConfiguration.designated
                                            : Udesk.enums.pushObjectTypes.email.name}
                                    </div>
                                )}
                                <div className="massage-push-configuration-child-row-content">
                                    <Input
                                        defaultValue={pushConf.actionDetails.targetEmails}
                                        onChange={actions.onInputChange.params(
                                            pushConf.actionType,
                                            'targetEmails'
                                        )}
                                        placeholder={
                                            locales.components.massageConfiguration
                                                .targetEmailsPlaceholder
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <If
                        condition={
                            parseInt(pushConf.actionType, 10) ===
                            Udesk.enums.messagePushType.email.id
                        }
                    >
                        <div className="massage-push-configuration-row">
                            <div className="massage-push-configuration-row-label">
                                {locales.components.massageConfiguration.subject}
                            </div>
                            <div className="massage-push-configuration-row-content">
                                <Input
                                    defaultValue={pushConf.actionDetails.subject}
                                    onChange={actions.onInputChange.params(
                                        pushConf.actionType,
                                        'subject'
                                    )}
                                />
                            </div>
                        </div>
                    </If>
                </If>
                {/* sdk */}
                <If
                    condition={
                        parseInt(pushConf.actionType, 10) === Udesk.enums.messagePushType.sdk.id
                    }
                >
                    <div className="massage-push-configuration-row">
                        <div
                            className="massage-push-configuration-row-label"
                            style={{ marginRight: 10 }}
                        >
                            {locales.components.massageConfiguration.SDKID}
                        </div>
                        <div className="massage-push-configuration-row-content">
                            <Input
                                defaultValue={pushConf.actionDetails.sdk}
                                onChange={actions.onInputChange.params(pushConf.actionType, 'sdk')}
                            />
                        </div>
                    </div>
                </If>

                {parseInt(pushConf.actionType, 10) === Udesk.enums.messagePushType.ticket.id ? (
                    <TicketConfig
                        value={pushConf.actionDetails}
                        onChange={(v) => actions.onTicketConfigChange(v)}
                    />
                ) : null}

                {parseInt(pushConf.actionType, 10) ===
                Udesk.enums.messagePushType.callingRobot.id ? (
                    <CallingRobotConfig
                        value={pushConf.actionDetails}
                        onChange={(v) => actions.onCallingRobotConfigChange(v)}
                    />
                ) : null}

                {/* 富文本编辑器 */}
                <If
                    condition={
                        ![
                            Udesk.enums.messagePushType.interfacePush.id,
                            Udesk.enums.messagePushType.udesk.id,
                            Udesk.enums.messagePushType.ticket.id,
                            Udesk.enums.messagePushType.callingRobot.id,
                        ].includes(parseInt(pushConf.actionType, 10))
                    }
                >
                    <div className="massage-push-configuration-row massage-push-configuration-last-row">
                        <div className="massage-push-configuration-row-label">
                            {locales.components.massageConfiguration.content}
                        </div>
                        <div className="massage-push-configuration-row-content">
                            <BraftEditor
                                style={braftEditorStyle}
                                extendControls={extendControls(pushConf)}
                                value={pushConf.actionDetails._editorState}
                                onChange={actions.handleEditorChange.params(pushConf.actionType)}
                                language={language}
                            />
                        </div>
                    </div>
                </If>
            </React.Fragment>
        );
    }
}
